import { Dexie, Table } from 'dexie';
import {
  Chore,
  Activity,
  Household,
  OfflineQueueItem,
  UUID,
} from '../domain';

export interface DbSetting {
  key: string;
  value: string;
}

export class localDB extends Dexie {
  chores!: Table<Chore, UUID>;
  activities!: Table<Activity, UUID>;
  households!: Table<Household, UUID>;
  offlineQueue!: Table<OfflineQueueItem, number>;
  settings!: Table<DbSetting, string>;

  constructor() {
    super('LocalDB');
    this.version(1).stores({
      chores: 'id, name, interval_frequency, household_id, created_at, assigned_to',
      activities: 'id, chore_id, completed_at, by_user',
      users: 'id, name, email',
      households: 'id, name, created_at, owner_id, member_ids, member_display_names',
      offlineQueue: '++id, timestamp, type, choreId',
    });
    this.version(2).stores({
      chores: 'id, name, household_id, created_at',
      activities: 'id, chore_id, completed_at, by_user',
      users: 'id, name, email',
      households: 'id, name, created_at, owner_id, member_ids, member_display_names',
      offlineQueue: '++id, timestamp, type, choreId',
    }).upgrade(tx =>
      tx.table('chores').toCollection().modify((chore: Record<string, unknown>) => {
        if (typeof chore.interval_frequency === 'number') {
          chore.schedule = { type: 'minutes', interval: chore.interval_frequency };
          delete chore.interval_frequency;
        }
      })
    );
    this.version(3).stores({
      chores: 'id, name, household_id, created_at',
      activities: 'id, chore_id, completed_at, by_user',
      users: null,
      households: 'id, name, created_at, owner_id, member_ids, member_display_names',
      offlineQueue: '++id, timestamp, type, choreId',
    });
    this.version(4).stores({
      chores: 'id, name, household_id, created_at',
      activities: 'id, chore_id, completed_at, by_user',
      households: 'id, name, created_at, owner_id, member_ids, member_display_names',
      offlineQueue: '++id, timestamp, type, choreId',
      settings: 'key',
    });
  }
}

export const db = new localDB();
